import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { CreateElement } from '@src/vue'
import './not-supported-style.sass'

@Component
export class MobileLandscapeNotSupportedOverlay extends Vue {

  render (h: CreateElement) {
    return (
      <div class='unsupported-overlay'>
        <div>{this.$t('PAGE.CONTENT.UNSUPPORTED_MOBILE_LANDSCAPE')}</div>
      </div>
    )
  }
}
